// Website data — Lumière Entertainment (English)

export const BRAND = {
  name: "LUMIÈRE",
  tagline: "ENTERTAINMENT",
  hero_kicker: "Performances · Creative Concepts · Immersive Experiences",
  hero_title_top: "Nights",
  hero_title_mid: "You Will",
  hero_title_bottom: "Never",
  hero_script: "Forget",
  hero_sub:
    "Bespoke entertainment & production for weddings, corporate events, hotels, brand activations and destination events across Europe and the Mediterranean.",
  phone: "694 316 7877",
  email: "stamatina.kanta@yahoo.com",
  instagram: "stam_kanta",
};

export const PERFORMANCE_ACTS = [
  {
    id: "golden-performer",
    name: "Golden Performer",
    desc: "A solo performance with golden costumes, choreographed sparkle and a mesmerizing stage presence.",
    image: "/generated/golden-performer.jpg",
  },
  {
    id: "aerial-duo",
    name: "Aerial Duo",
    desc: "Aerial numbers in silk and hoop — power, fluidity and poetic grace over the dance floor.",
    image:
      "/generated/act-aerial-duo.jpg",
  },
  {
    id: "fire-performance",
    name: "Fire Performance",
    desc: "Controlled flames and high-intensity spectacle — for a unique moment everyone will remember.",
    image: "/generated/fire-performance-1.jpg",
  },
  {
    id: "oriental-show",
    name: "Oriental Show",
    desc: "A journey to the East with rich costumes, mysticism and traveling melodies.",
    image:
      "/generated/arabian-nights-5.jpg",
  },
  {
    id: "tribal-dance",
    name: "Tribal Dance",
    desc: "Primitive rhythms, dancers in trance, feathers, paint and storytelling through movement.",
    image:
      "/generated/act-tribal-dance.jpg",
  },
  {
    id: "live-music",
    name: "Live Music Band",
    desc: "World-class live bands and soloists — the soundtrack to your evening.",
    image:
      "/generated/act-live-music-band.jpg",
  },
];

export const EVENT_WORLDS = [
  {
    id: "disco-80s",
    name: "Disco 80's Experience",
    desc: "Journey through the golden decade — shiny costumes, funk beats and energy that never fades.",
    image: "/generated/disco-80s-hero.png",
    gallery: [
      "/generated/disco-80s-hero.png",
      "/generated/disco-80s-4.webp",
      "/generated/disco-80s-5.webp",
      "/generated/disco-80s-2.webp",
      "/generated/disco-80s-3.jpg",
    ],
  },
  {
    id: "white-party",
    name: "White Party Experience",
    desc: "A backdrop in white — clean lines, light, silhouettes and high aesthetics.",
    image: "/generated/white-party-1.jpg",
    video: "/generated/concept-white-party.mp4",
    gallery: [
      "/generated/white-party-1.jpg",
      "/generated/white-party-2.jpg",
      "/generated/white-party-3.jpg",
    ],
  },
  {
    id: "arabian-nights",
    name: "Arabian Nights Experience",
    desc: "Morocco, India and Bosphorus in one night — silks, lanterns, ouds and oriental rhythms.",
    image: "/generated/arabian-nights-5.jpg",
    video: "/generated/concept-arabian-nights.mp4",
    gallery: [
      "/generated/arabian-nights-5.jpg",
      "/generated/arabian-nights-3.jpg",
      "/generated/arabian-nights-2.jpg",
      "/generated/arabian-nights-4.jpg",
    ],
  },
  {
    id: "sicilian-dolce-vita",
    name: "Sicilian Dolce Vita Experience",
    desc: "Amalfi coast energy on a summer evening — lemon crowns, tiered ruffled yellow dresses, majolica ceramics, Dean Martin in Mambo Italiano and a Mediterranean sunset.",
    image: "/generated/sicilian-dolce-1.jpg",
    gallery: [
      "/generated/sicilian-dolce-3.jpg",
      "/generated/sicilian-dolce-1.jpg",
      "/generated/sicilian-dolce-2.jpg",
    ],
  },
];

export const IMMERSIVE_ACTS = [
  "LED Costume Shows",
  "Laser Performances",
  "Digital Performance Acts",
  "Interactive Experiences",
];

export const DECOR_CONCEPTS = [
  "Scene Design",
  "Flower arrangements",
  "Immersive Lighting",
  "Luxury Styling",
  "Lounge Concepts",
];

export const WHY_ME = [
  { name: "World Class Artists", icon: "user" },
  { name: "Creative Concepts", icon: "lightbulb" },
  { name: "Luxury Experiences", icon: "gem" },
  { name: "Bespoke Productions", icon: "sparkles" },
  { name: "International Experience", icon: "globe" },
];

export const CLIENTS = [
  { name: "Luxury Weddings", icon: "heart", slug: "luxury-weddings" },
  { name: "Private Parties", icon: "party-popper", slug: "private-parties" },
  { name: "Corporate Events", icon: "building-2", slug: "corporate-events" },
  { name: "Hotels & Resorts", icon: "hotel", slug: "hotels-and-resorts" },
  { name: "Brand Activations", icon: "megaphone", slug: "brand-activations" },
  { name: "Destination Events", icon: "map-pin", slug: "destination-events" },
];

export const PORTFOLIO = [
  {
    src: "/generated/golden-performer-1.jpg",
    label: "Golden Performer",
    span: "col-span-2 row-span-2",
  },
  {
    src: "/generated/fire-performance-1.jpg",
    label: "Fire Performance",
    span: "col-span-1 row-span-1",
  },
  {
    src: "/generated/act-aerial-duo.jpg",
    label: "Aerial Duo",
    span: "col-span-1 row-span-1",
  },
  {
    src: "/generated/disco-80s-hero.png",
    label: "Disco 80's",
    span: "col-span-1 row-span-2",
  },
  {
    src: "/generated/arabian-nights-2.jpg",
    label: "Arabian Nights",
    span: "col-span-2 row-span-1",
  },
  {
    src: "/generated/act-live-music-band.jpg",
    label: "Laser Performance",
    span: "col-span-1 row-span-1",
  },
  {
    src: "/generated/sicilian-dolce-3.jpg",
    label: "Sicilian Dolce Vita",
    span: "col-span-2 row-span-1",
  },
  {
    src: "/generated/arabian-nights-5.jpg",
    label: "Oriental Show",
    span: "col-span-1 row-span-1",
  },
];

export const EVENT_TYPES = [
  "Luxury Wedding",
  "Private party",
  "Corporate Event",
  "Hotel & Resort",
  "Brand Activation",
  "Destination Event",
  "Other",
];

/* -------- Additional content -------- */

export const OUR_SERVICES = [
  { name: "Entertainment Design", icon: "lightbulb" },
  { name: "Artists & Shows", icon: "sparkles" },
  { name: "Costumes & Styling", icon: "gem" },
  { name: "Dance Performances", icon: "star" },
  { name: "Thematic Concepts", icon: "wand-2" },
  { name: "Corporate Entertainment", icon: "briefcase" },
  { name: "Music & Party Direction", icon: "music-2" },
];

export const SIGNATURE_EXPERIENCES = [
  {
    name: "Sicilian Dolce Vita Night",
    desc: "Amalfi energy, lemon crowns, yellow tulle clothes and mamma-mia soundtrack until dawn.",
    image: "/generated/sicilian-dolce-3.jpg",
  },
  {
    name: "Glam Disco Celebration",
    desc: "Glitter, performers, DJs and high intensity party flow.",
    image: "/generated/disco-80s-hero.png",
  },
  {
    name: "White Island Party",
    desc: "Boho-luxury beach atmosphere with curated entertainment.",
    image: "/generated/white-party-1.jpg",
  },
  {
    name: "Arabian Nights",
    desc: "Oriental acts, lanterns, silks and mysterious atmosphere.",
    image: "/generated/arabian-nights-2.jpg",
  },
];

export const EVENT_CONCEPTS = [
  {
    num: "00",
    name: "Luxury Brand Editorial Concept",
    tags: ["Brand Experience", "Editorial", "Cinematic"],
    image:
      "/generated/concept-signature-installations.jpg",
    video: "/generated/concept-luxury-brand-editorial.mp4",
  },
  {
    num: "01",
    name: "Nymphs of the Sea",
    tags: ["Mythical", "Ethereal", "Marine Inspiration"],
    image: "/generated/sea-nymphs-story-1.jpg",
    video: "/generated/concept-nymphs-of-the-sea.mp4",
  },
  {
    num: "02",
    name: "Ethnic Rituals",
    tags: ["Ritual", "Mysterious", "Sunset Ceremony"],
    image:
      "/generated/tribal-show.jpg",
  },
  {
    num: "03",
    name: "Sunset Dinner & Piano Grooves",
    tags: ["Stylish", "Live Music", "Sophisticated"],
    image:
      "/generated/concept-fly-me-to-the-moon.jpg",
  },
  {
    num: "04",
    name: "Sea Nymphs Yacht Experience",
    tags: ["Luxury Yacht", "Aerial", "Ocean Magic"],
    image: "/generated/sea-nymphs-yacht-hero.jpg",
  },
  {
    num: "05",
    name: "Secret Location Dinner",
    tags: ["Exclusive", "Intimate", "Unforgettable"],
    image:
      "/generated/concept-grazing-lounge.jpg",
  },
  {
    num: "06",
    name: "Wellness & Sound Experience",
    tags: ["Healing", "Mindful", "Transformative"],
    image:
      "/generated/concept-wellness-sound.jpg",
  },
  {
    num: "07",
    name: "Mediterranean Grazing & Lounge Night",
    tags: ["Flavors", "Lounge", "Social"],
    image:
      "/generated/concept-grazing-lounge.jpg",
  },
  {
    num: "08",
    name: "Wedding Cultural Concepts",
    tags: ["Traditional", "Colorful", "Bespoke Ceremony"],
    image: "/generated/wedding-cultural.jpg",
  },
  {
    num: "09",
    name: "Tribal Show",
    tags: ["Fire", "Wings", "Rhythmic Ritual"],
    image: "/generated/tribal-show.jpg",
    video: "/generated/concept-tribal-show.mp4",
  },
  {
    num: "10",
    name: "Andalusian Flamenco Nights",
    tags: ["Gastronomy", "Decor", "Live Entertainment"],
    image: "/generated/andalusian-flamenco.jpg",
    video: "/generated/concept-andalusian-flamenco.mp4",
  },
  {
    num: "11",
    name: "Glam Disco Celebration",
    tags: ["Shine", "Retro", "High-Energy Party"],
    image:
      "/generated/disco-80s-hero.png",
    video: "/generated/concept-glam-disco-celebration.mp4",
    gallery: [
      "/generated/disco-80s-hero.png",
      "/generated/disco-80s-2.jpg",
      "/generated/disco-80s-3.jpg",
      "/generated/disco-80s-4.jpg",
    ],
  },
];

export const PROCESS_STEPS = [
  {
    num: "01",
    title: "The First Date",
    desc: "We listen to your vision, the style of the event and your audience.",
    icon: "phone",
  },
  {
    num: "02",
    title: "The Creative Concept",
    desc: "We plan the theme, flow and atmosphere of the evening — moodboard in mockup.",
    icon: "lightbulb",
  },
  {
    num: "03",
    title: "Production & Organization",
    desc: "We set up performers, music, lighting and every detail behind the curtain.",
    icon: "calendar",
  },
  {
    num: "04",
    title: "Showtime",
    desc: "On the day of the event, you simply experience the evening — the rest, ours.",
    icon: "sparkles",
  },
];

export const TESTIMONIALS = [
  {
    quote: "Cinematic, elegant, without a single unsafe moment — they left us speechless.",
    author: "Maria & Alexander",
    venue: "Wedding · Santorini",
  },
  {
    quote: "Our guests are still talking about this night.",
    author: "The Bay Hotel",
    venue: "Grand Opening · Mykonos",
  },
  {
    quote: "They turned a company dinner into a whole experience.",
    author: "Nova Brands",
    venue: "Brand Activation · Milan",
  },
];
